export default "__VITE_ASSET__CuBqPOqc__"